/* Product imagery only; the order app is not queried or modified. */
(() => {
  if (window.grzCatalogV11) return;
  window.grzCatalogV11 = true;
  let dialog;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-grz-image]');
    if (!button) return;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'grz-v11-lightbox';
      const close = document.createElement('button');
      close.type = 'button'; close.textContent = '×';
      close.setAttribute('aria-label', document.documentElement.lang === 'ar' ? 'إغلاق الصورة' : 'Fermer la photo');
      close.addEventListener('click', () => dialog.close());
      const image = document.createElement('img');
      dialog.append(close, image); document.body.append(dialog);
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    }
    const image = dialog.querySelector('img');
    image.src = button.dataset.grzImage;
    image.alt = button.querySelector('img')?.alt || '';
    dialog.showModal();
  });
  let priceFrame;
  const syncPrice = () => {
    cancelAnimationFrame(priceFrame);
    priceFrame = requestAnimationFrame(() => {
      const current = document.querySelector('product-info > .product-page-price');
      if (!current) return;
      document.querySelectorAll('[data-grz-linked-price]').forEach(target => {
        if (target.innerHTML !== current.innerHTML) target.innerHTML = current.innerHTML;
      });
    });
  };
  const nativePrice = document.querySelector('product-info > .product-page-price');
  if (nativePrice) new MutationObserver(syncPrice).observe(nativePrice, {subtree:true,childList:true,characterData:true});
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, event => {
      const variant = event.data?.variant;
      if (!variant) return;
      const isRed = /^(red|rouge|أحمر)$/i.test(variant.option1 || '');
      document.querySelectorAll('[data-grz-variant-image]').forEach(image => {
        image.src = isRed ? image.dataset.grzRedSrc : image.dataset.grzBlackSrc;
        image.classList.toggle('grz-v11-selected-photo', isRed);
        const enlarge = image.closest('[data-grz-image]');
        if (enlarge) enlarge.dataset.grzImage = image.src;
        image.closest('.grz-v11-hero')?.classList.toggle('grz-v11-light-variant', isRed);
      });
    });
  }
})();
